class InitAppData {

    constructor() {
        this.init();
    }

    init(){
        this.version = 2; //localStorage.getItem('version') ?? 2;

        this.title = "𝐋𝐎𝐕𝐄 𝐒𝐓𝐈𝐓𝐂𝐇 | ВИШИВКА";

        this.email = 'oliayrina@gmail.com';

        this.phoneKyivstar = '+380 (98) 740 7162';
        this.phoneLifecell = '+38 (093) 000 12 34';
        this.phoneVodafone = '+38 (095) 000 12 34';

        this.socialYouTube = 'https://www.youtube.com/lovestitch.ua';
        this.socialInstagram = 'https://www.instagram.com/lovestitch.ua';
        this.socialFacebook = 'https://facebook.com/lovestitch.ua';

        this.messangerTelegram= 'https://t.me/lovestitch.ua';
        this.messangerWhatsapp= 'https://api.whatsapp.com/send?phone=0980751357';
        this.messangerViber= 'viber://contact?number=%2B0980751357';

        this.address = 'Житомир, Україна';
    }

    updateVersion(version){
        localStorage.setItem('version', version);

        this.init()
    }
}

export default new InitAppData();
